/**
 * Custom error types for authentication
 */

import { m } from "@/paraglide/messages";

export const errorMessages: Record<string, string> = {
	recovery_code_invalid: m.auth_recovery_code_invalid(),
	user_setup_incomplete: m.auth_user_setup_incomplete(),
	email_token_expired: m.auth_email_token_expired(),
	totp_invalid: m.auth_totp_invalid(),
	totp_uri_invalid: m.auth_totp_uri_invalid(),
	totp_not_enrolled: m.auth_totp_not_enrolled(),
	totp_duplicate_name: m.auth_totp_duplicate_name(),
	webauthn_invalid_handle: m.auth_webauthn_invalid_handle(),
	webauthn_cancelled: m.auth_webauthn_cancelled(),
	webauthn_not_supported: m.auth_webauthn_not_supported(),
	passkey_public_key_invalid: m.auth_webauthn_public_key_invalid(),
	general_auth_error: m.auth_general_auth_error(),
};

export class LoginError extends Error {
	code: string;

	constructor(code: string | undefined) {
		super(errorMessages[code ?? "general_auth_error"]);
		this.code = code ?? "general_auth_error";
		this.name = "LoginError";
		Object.setPrototypeOf(this, LoginError.prototype);
	}
}

export function isLoginError(error: unknown): error is LoginError {
	return error instanceof LoginError;
}
